module.exports = __webpack_public_path__ + "static/img/ch.9f295dfc.svg";